import styled from "styled-components";
import { Modal as BaseModal } from "@wrstudios/components";
import {
  Container,
  Status,
  Price,
  PricePerSqft
} from "./live-listing-details-aside";

export const AdjustedContainer = styled(Container)`
  background-color: ${({ theme }) => theme.styleGuide.colors.gray[200]};
`;

export const AdjustedStatus = styled(Status)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};
`;

export const AdjustedPrice = styled(Price)`
  font-size: 2.4rem;
  line-height: 3rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[900]};

  ${({ theme }) => theme.media.sm`
    font-size: 1.6rem;
    line-height: 2rem;
  `}
`;

export const AdjustedPriceArrow = styled.span`
  color: ${({ theme, isPositive }) =>
    isPositive
      ? theme.styleGuide.colors.green[700]
      : theme.styleGuide.colors.red[600]};
`;

export const AdjustedPricePerSqft = styled(PricePerSqft)`
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};
`;

export const Name = styled.input`
  width: 100%;
  font-size: 1.4rem;
  line-height: 2rem;
  padding: 1.2rem 1.6rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};
  border-radius: 0.4rem;
  background: transparent;
  border: 0;
  appearance: none;
  outline: none;
  position: relative;

  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
  `}

  &:focus {
    background-color: ${({ theme }) => theme.styleGuide.colors.white};
    box-shadow: ${({ theme }) => theme.styleGuide.shadows.overlay},
      0 0 0 0.1rem ${({ theme }) => theme.live.colors.primary};
    z-index: 2;
  }
`;

export const Value = styled.input`
  width: 100%;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 2rem;
  padding: ${({ isAdd }) =>
    isAdd ? "1.2rem 1.6rem" : "1.2rem 0 1.2rem 1.6rem"};
  text-align: right;
  color: ${({ theme }) => theme.styleGuide.colors.gray[900]};
  border-radius: 0.4rem;
  background: transparent;
  border: 0;
  appearance: none;
  outline: none;
  position: relative;

  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
  `}

  &::placeholder {
    color: ${({ theme }) => theme.styleGuide.colors.gray[600]};
  }

  &:focus {
    background-color: ${({ theme }) => theme.styleGuide.colors.white};
    box-shadow: ${({ theme }) => theme.styleGuide.shadows.overlay},
      0 0 0 0.1rem ${({ theme }) => theme.live.colors.primary};
    z-index: 2;
  }
`;

export const Remove = styled.button`
  display: flex;
  flex-shrink: 0;
  padding: 1.2rem;
  appearance: none;
  cursor: pointer;

  svg {
    width: 2rem;
    height: 2rem;
    fill: ${({ theme }) => theme.styleGuide.colors.gray[700]};
  }
`;

export const Info = styled.button`
  padding: 0;
  cursor: pointer;
  appearance: none;

  svg {
    width: 1.8rem;
    height: 1.8rem;
    margin-right: -0.4rem;
    fill: ${({ theme }) => theme.styleGuide.colors.gray[700]};
  }
`;

export const ModalContent = styled(BaseModal.Content)`
  width: 100%;
  max-width: 75.4rem;
`;

export const ModalText = styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
  margin: 0;

  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
  `}
`;

export const Add = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 2rem;
  padding: 1.6rem 1.2rem 1.4rem;
  border: 0;
  background-color: transparent;
  color: ${({ theme }) => theme.live.colors.primary};
  appearance: none;
  cursor: pointer;

  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
  `}

  svg {
    width: 2rem;
    height: 2rem;
    margin-right: 1rem;
    fill: ${({ theme }) => theme.live.colors.primary};
  }
`;
